var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.59 30.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.6;}.b{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.61,3.59V.19A16,16,0,0,0,15.3,0,15.88,15.88,0,0,0,13,.19v3.4Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.65,5.38,6.25,3a16.54,16.54,0,0,0-1.77,1.5A16.54,16.54,0,0,0,3,6.25l2.4,2.4Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.59,13H.19A15.88,15.88,0,0,0,0,15.3a16,16,0,0,0,.19,2.31h3.4Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.38,21.94,3,24.34a14.78,14.78,0,0,0,1.5,1.77,15.46,15.46,0,0,0,1.77,1.5l2.4-2.4Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13,27V30.4a14.14,14.14,0,0,0,4.62,0V27Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.94,25.21l2.4,2.4a14.1,14.1,0,0,0,3.27-3.27l-2.4-2.4Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27,17.61H30.4a14.14,14.14,0,0,0,0-4.62H27Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.21,8.65l2.4-2.4a15.46,15.46,0,0,0-1.5-1.77A14.78,14.78,0,0,0,24.34,3l-2.4,2.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipboard);
export default __webpack_public_path__ + "static/media/chipboard.5c800c607d4bddb19b0c4056a7feb4fa.svg";
export { ForwardRef as ReactComponent };